import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, Activity } from "lucide-react";

export default function Postmaster() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    let cancelled = false;
    api.get("/admin/dashboard").then(r => {
      if (!cancelled) setData(r.data);
    });
    return () => { cancelled = true; };
  }, [refreshKey]);

  async function pull() {
    setBusy(true);
    try { await api.post("/admin/postmaster/pull"); setRefreshKey(k => k + 1); }
    finally { setBusy(false); }
  }
  async function resetBudgets() {
    setBusy(true);
    try { await api.post("/admin/budgets/reset"); setRefreshKey(k => k + 1); }
    finally { setBusy(false); }
  }

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-3xl font-black tracking-tight">Postmaster &amp; Cron</h1>
          <div className="text-zinc-500 text-sm mt-1">
            Pulls happen daily in production. Trigger manually here. <span className="text-amber-500">(MOCKED until GCP service account is wired in Slice 6)</span>
          </div>
        </div>
        <div className="flex gap-2">
          <button
            onClick={pull}
            disabled={busy}
            className="inline-flex items-center gap-2 bg-white text-zinc-950 hover:bg-zinc-200 disabled:opacity-50 px-4 py-2 rounded-sm text-sm font-semibold"
          >
            {busy ? <Loader2 className="animate-spin" size={14} /> : <Activity size={14} />}
            Pull Postmaster
          </button>
          <button
            onClick={resetBudgets}
            disabled={busy}
            className="inline-flex items-center gap-2 border border-zinc-700 hover:border-white text-zinc-300 hover:text-white px-4 py-2 rounded-sm text-sm font-semibold"
          >
            Reset Daily Budgets
          </button>
        </div>
      </div>

      <div className="border border-zinc-800 rounded-sm">
        <div className="grid grid-cols-[1fr_120px_120px_120px_140px] bg-zinc-900/70 border-b border-zinc-800 label-tiny px-4 py-2">
          <div>Domain</div><div>Score</div><div>IP Rep</div><div>Domain Rep</div><div>Spam Rate</div>
        </div>
        <div className="divide-y divide-zinc-800">
          {(!data || data.postmaster.length === 0) && <div className="px-4 py-6 text-sm text-zinc-500">No readings yet. Trigger a pull.</div>}
          {data?.postmaster.map((p, i) => (
            <div key={i} className="grid grid-cols-[1fr_120px_120px_120px_140px] items-center px-4 py-2 mono text-sm">
              <div className="text-zinc-200 truncate">{p.domain}</div>
              <div className="text-amber-500">{p.score?.toFixed(1)}</div>
              <div className="text-zinc-300">{p.ip_reputation || "—"}</div>
              <div className="text-zinc-300">{p.domain_reputation || "—"}</div>
              <div className="text-zinc-400">{(p.spam_rate ?? 0).toFixed(3)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
